import styled from "@emotion/styled";


export const PaymentDetailsWrapper = styled.div`
  .price-details {
    margin-top: -4px;
    margin-bottom: 8px;
  };

  .content-layout {
    margin: 0px;
    border-radius: 8px;
  };

  .accordion-title-bundle-text-layout {
    margin-top: 0px
  }
  
  margin: 0px 20px;
  padding: 0px 0px;
  
`;

export const Wrapper = styled.div`
margin-left: 6px;
margin-bottom: 10px;
`;
